import { getToken, setToken, removeToken } from '@/utils/auth';
// import { toLogin, logoutApi, getUserInfo } from '@/api/base';
import { toLogin, logoutApi, getUserInfoFeishu } from '@/api/base';
import { switchOtherUserLogin } from '@/api/user'

const user = {
  state: {
    token: getToken() || '',
    permission: [],
    username: '',
    mobile: '',
    open_id: '',
    union_id: '',
    email: '',
    city: '',
    is_super: 0 // 0 1
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      removeToken(); // 每次设置前，先移除之前存储的
      setToken(token);
      state.token = token;
    },
    SET_BASE_INFO: (state, userInfo) => {
      state.username = userInfo.name;
      state.mobile = userInfo.mobile;
      state.open_id = userInfo.open_id;
      state.is_super = userInfo.is_super || 0;
      // state.email = userInfo.email;
      // state.realname = userInfo.realname;
      // state.status = userInfo.status;
      // state.created_at = userInfo.created_at;
      state.permission = userInfo.permission; // 权限
    }
  },
  actions: {
    Login({ commit }, { open_id, code, status }) {
      return new Promise((resolve, reject) => {
        toLogin({ open_id, code, status }).then(res => {
          if (res.code === 0) {
            // login接口返回成功
            const token = res.data.token;
            commit('SET_TOKEN', token);
            resolve(res);
          } else {
            commit('SET_TOKEN', '');
            resolve(res)
          }
        }).catch(err => {
          reject(err);
        })
      })
    },

    switchLogin({ commit }, open_id) {
      return new Promise((resolve, reject) => {
        switchOtherUserLogin(open_id).then(res => {
          if (res.code === 0) {
            const token = res.data.token;
            commit('SET_TOKEN', token);
            resolve(res);
          } else {
            commit('SET_TOKEN', '');
            resolve(res)
          }
        }).catch(err => {
          reject(err);
        })
      })
    },

    getUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfoFeishu(state.token).then(res => {
          if (res.code === 0) {
            try {
              const userInfo = res.data;
              console.log('userInfo', userInfo)
              commit('SET_BASE_INFO', userInfo);// 存储用户数据
              resolve(userInfo);
            } catch (err) {
              console.log(err, '-----------')
            }
          } else {
            reject(new Error('用户基本信息获取失败'));
          }
        }).catch(err => {
          reject(err);
        });
      });
    },
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        logoutApi().then(res => {
        }).catch(error => {
          console.log(error);
        }).finally(() => {
          removeToken();
          resolve();
        });
      });
    }
  }
}
export default user;
